import React from "react";

import {useTranslation} from "react-i18next";

import Typography from "@mui/material/Typography";
import {COLORS} from "../../../../../../../../config/constants";

const ModalSettingsNotFound = () => {

  const { t } = useTranslation()

  return <div className='modal_settings__not-found'>
    <Typography variant='body1' sx={{ color: COLORS.BLACK, padding: '8px 0' }}>
      {t('calc__text__summary__youDontHaveAnyTemplatesYet')}.
    </Typography>
  </div>
}

export default ModalSettingsNotFound
